let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d6Zdr")).then(() => parcelRequire('k7LtZ'));